import { useEffect } from 'react'

import { HOME_ID } from './context'
import type { CommandPaletteSection } from './types'
import { useCommandPalette } from './use-command-palette'

/** batch variant: registers every section in the list, tears them down on
 * unmount. caller memoizes the array (or every entry stays stable) so the
 * effect doesn't thrash on every render. used by the pages bootstrap, which
 * wires every sidebar entry into the palette.
 */
export function useRegisterPaletteSections(sections: CommandPaletteSection[]) {
  const { registerSection, unregisterSection } = useCommandPalette()

  useEffect(() => {
    for (const section of sections) {
      if (section.id === HOME_ID) {
        throw new Error(`section id '${HOME_ID}' is reserved`)
      }
      registerSection(section)
    }
    return () => {
      for (const section of sections) {
        unregisterSection(section.id)
      }
    }
  }, [registerSection, unregisterSection, sections])
}
